import actions from './actions';
import mutations from './mutations';

function state() {
    return {
        userAccessDialogOpen: false,
        groupAccessDialogOpen: false,

        stats: {
            allowed_users_count: 0,
            denied_users_count: 0,
            allowed_groups_count: 0,
            denied_groups_count: 0
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};